import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBanner } from "namirasoft-site-react";
import { Component } from 'react';
import { DonateLayout } from "../DonateLayout";
import { DonateRouterProps } from "../DonateRouterProps";

interface DonatePageProps extends NSARouterMakerResult, DonateRouterProps { }

export default class DonateSuccessPage extends Component<DonatePageProps>
{
    override render()
    {
        return (
            <DonateLayout
                {...this.props}
                action={{
                    title: "Donate",
                    menus: {}
                }}
            >
                <NSBanner
                    imageLeft={{
                        src: "https://static.namirasoft.com/image/concept/bot/payment-successful.png",
                        alt: "payment successful bot"
                    }}
                    imageRight={null}
                    title={{
                        text: "Thank you for your Donation!",
                        style: { color: "green" }
                    }}
                    description={{
                        text: "Every donation, large or small, helps us improve our apps and serve the community. Thank you again for making a difference."
                    }}
                />
            </DonateLayout>
        );
    }
}